import { Link, useLocation } from 'react-router-dom';

const items = [
  { href: '/', label: '首页', icon: '/images/nav/nav_shouye.png' },
  { href: '/invite', label: '邀请', icon: '/images/nav/nav_yaoqing.png' },
  { href: '/asset-restore', label: '我的资产', icon: '/images/nav/nav_zichan.png' },
  { href: '/investment-refund', label: '投资补偿', icon: '/images/nav/nav_tuipei.png' },
  { href: '/cards', label: '退赔卡', icon: '/images/nav/nav_tuipei.png' },
  { href: '/my-property', label: '我的房产', icon: '/images/nav/nav_movein.png' },
  { href: '/videos', label: '视频回放', icon: '/images/nav/nav_video.png' },
  { href: '/profile', label: '个人中心', icon: '/images/nav/nav_geren.png' },
];

export default function NavBar() {
  const { pathname } = useLocation();

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-10 bg-[#7a1518]">
      <div className="mx-auto max-w-md">
        <div className="flex items-end justify-around px-2 pt-3 pb-4">
          {items.map((i) => {
            const active = pathname === i.href;
            return (
              <Link key={i.href} to={i.href} className="flex flex-col items-center gap-0.5">
                <img
                  src={i.icon}
                  alt={i.label}
                  className="w-7 h-6"
                  style={{ opacity: active ? 1 : 0.6 }}
                />
                <span className={`text-[11px] ${active ? 'text-[#f5d998] font-bold' : 'text-white/70'}`}>
                  {i.label}
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </nav>
  );
}
